import { createSelector } from "@reduxjs/toolkit";

const defaultArr = [];
const defaultObj = {};

export const getCartItemsCount = ({ cart }) => cart?.order?.itemCount;
export const getCartOrder = ({ cart }) => cart?.order;
export const getCartOrderFetched = ({ cart }) => cart?.orderFetched;
export const getCartOrderFetching = ({ cart }) => cart?.orderFetching;
export const getCartOrderId = ({ cart }) => cart?.order?.id;
export const getCartOrderLineItems = ({ cart }) => cart?.order?.lineItems || defaultArr;
export const getCartOrderProductSets = ({ cart }) => cart?.order?.productSets || defaultArr;
export const getCartOrderMedleySets = ({ cart }) => cart?.order?.medleyItemSets || defaultArr;
export const getCartOrderNumber = ({ cart }) => cart?.order?.number;
export const getOrderUseGlobalPoint = ({ cart }) => cart?.order?.useGlobalPoint || false;
export const getOrderUseWalletMoney = ({ cart }) => cart?.order?.useWalletMoney || false;
export const getOrderUseStoreSpecificPoints = ({ cart }) =>
  cart?.order?.useStoreSpecificPoint || false;
export const getOrderTeamWalletId = ({ cart }) => cart?.order?.teamId;
export const getCartCurrencyCode = ({ cart }) => cart?.order?.billedCurrencyId;
export const getCartCountryId = ({ cart }) => cart?.order?.countryId;
export const getCartOrderPlatformFee = ({ cart }) => +cart?.order?.platformFee || 0;
export const getCartOrderTaxRecoveryFee = ({ cart }) => +cart?.order?.taxRecoveryFee || 0;
export const getCartPromoCode = ({ cart }) => cart?.order?.promoCode;
export const getCartPromoTotal = ({ cart }) => +(cart?.order?.promoTotal || 0);
export const getCartOrderAuthorizedPayments = ({ cart }) =>
  cart?.order?.authorizedPayments || defaultObj;
export const getIsCartOrderUpdated = ({ cart }) => cart?.order?.cartUpdated || false;
export const getCartOrderType = ({ cart }) => cart?.order?.type;
export const getCartTaxTotal = ({ cart }) => parseFloat(cart?.order?.taxTotal || 0);
export const getCartOrderHasCustomizable = ({ cart }) => cart?.order?.hasCustomizable;
export const getIsRejectionProcessingCompleted = ({ cart }) =>
  cart?.order?.isRejectionProcessingCompleted || false;
export const getCartOrderSendToMany = ({ cart }) => cart?.order?.sendToMany || false;
export const getCartOrderGiftDetailId = ({ cart }) => cart?.order?.giftDetail?.id || "";
export const getCartOrderRecipientZones = ({ cart }) => cart?.order?.recipientZones || defaultArr;
export const getCartOrderBundleName = ({ cart }) => cart?.order?.bundleName || "";
export const getCartProductZoneList = ({ cart }) => cart?.order?.cartProductZoneList || defaultArr;
export const getOrderBillingZipcode = ({ cart }) => cart?.order?.billingDetail?.zipcode;
export const getOrderBillingCountryId = ({ cart }) => cart?.order?.billingDetail?.countryId;
export const getOrderBillingCode = ({ cart }) => cart?.order?.billingCode || "";
export const getCartOrderVariantsMapping = ({ cart }) => cart?.order?.variantsMapping || defaultObj;
export const getCartOrderCurrency = ({ cart }) => cart?.order?.currency;
export const getReceivedItemsCount = ({ cart }) => cart?.order?.pricelessItemCount || 0;
export const getPompAddOnEnabled = ({ cart }) => cart?.order?.hasPomp || false;
export const getPompFee = ({ cart }) => parseFloat(cart?.order?.pompFee || 0);
export const getIsEligibleForPomp = ({ cart }) => cart?.order?.isEligibleForPomp || false;
export const getCartOrderAllowAnnonymousInvite = ({ cart }) =>
  cart?.order?.allowAnonymousInvite || false;
export const getIsCartUpdating = ({ cart }) => cart?.isCartUpdating || false;

export const getCartItemLogoIds = createSelector(getCartOrderLineItems, (lineItems) =>
  lineItems.map((item) => item.lineItemCustomization?.logoId).filter(Boolean),
);

export const getCartOrderShipAddressId = ({ cart }) => cart?.order?.shipAddressId;

export const getCartOrderBagTotal = ({ cart }) => +(cart?.order?.bagTotal || 0);

export const getCartOrderOutstandingBalance = ({ cart }) =>
  +cart?.order?.checkoutTotals?.outstandingBalance;
export const getCartOrderOutstandingBalanceWithoutTaxes = ({ cart }) =>
  +cart?.order?.cartTotals?.outstandingBalance;

export const getCartOrderwalletMoneyContribution = ({ cart }) =>
  +cart?.order?.checkoutTotals?.walletMoneyContribution;
export const getCartOrderWalletMoneyContributionWithoutTaxes = ({ cart }) =>
  +cart?.order?.cartTotals?.walletMoneyContribution;

export const getCartOrderTeamPointsContribution = ({ cart }) =>
  +cart?.order?.checkoutTotals?.teamPointsContribution;
export const getCartOrderTeamPointsContributionWithoutTaxes = ({ cart }) =>
  +cart?.order?.cartTotals?.teamPointsContribution;

export const getCartOrderStadiumPointsContribution = ({ cart }) =>
  +cart?.order?.checkoutTotals?.stadiumPointsContribution;
export const getCartOrderStadiumPointsContributionWithoutTaxes = ({ cart }) =>
  +cart?.order?.cartTotals?.stadiumPointsContribution;

export const getCardOrderShopPointsContribution = ({ cart }) =>
  +cart?.order?.checkoutTotals?.shopPointsContribution;
export const getCardOrderShopPointsContributionWithoutTaxes = ({ cart }) =>
  +cart?.order?.cartTotals?.shopPointsContribution;
